module.exports = __webpack_public_path__ + "static/bwvertwhite-699959f9a28289b80a0515e3e69e3284.svg";